// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditIntrospections_wrapper__y2ebZ {
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.EditIntrospections_mainTitle__ebg5Y {
  font-family: Inter;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 35px;
  letter-spacing: -0.016px;
  color: #4d4d4d;
  margin-left: -30px;
}

.EditIntrospections_backRow__jrDVe {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 16px;
  transition: -webkit-text-decoration 300ms ease-in-out;
  transition: text-decoration 300ms ease-in-out;
  transition: text-decoration 300ms ease-in-out, -webkit-text-decoration 300ms ease-in-out;
}
.EditIntrospections_backRow__jrDVe:hover {
  text-decoration: underline;
  cursor: pointer;
}
.EditIntrospections_back__PSAdj {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.001em;
  color: #5f6d7e;
}

.EditIntrospections_title__\\+kjbe {
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: -0.016px;
  color: #4d4d4d;
}

.EditIntrospections_introItem__rFk1I {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.EditIntrospections_btnsContainer__MyIt7 {
  width: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
}

.EditIntrospections_textarea__D4DHM {
  resize: none;
  width: 600px;
  min-height: 300px;
  box-sizing: border-box;
  padding: 15px 20px;
  border: 1px solid #d8dbdf;
  border-radius: 8px;
  box-shadow: 0px 0px 30px 5px rgba(95, 109, 126, 0.1);
  font-size: 15px;
  font-family: "Inter";
  font-weight: 400;
  line-height: 22px;
  color: #5f6d7e;
}

.EditIntrospections_exitButton__9Np8m {
  width: 180px;
  height: 44px;
  border-radius: 4px;
  gap: 8px;
  background: #ebebeb;
  font-family: "Inter";
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
  border: none;
  color: #808080;
  cursor: pointer;
}
.EditIntrospections_saveButton__UvExl {
  width: 180px;
  height: 44px;
  border-radius: 4px;
  gap: 8px;
  background: #cb9c2d;
  font-family: "Inter";
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
  border: none;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.EditIntrospections_exitButton__9Np8m:hover {
  background-color: #d1d0d0;
}
.EditIntrospections_saveButton__UvExl:hover {
  background-color: #ac8427;
}

@media screen and (max-width: 768px) {
  .EditIntrospections_btnsContainer__MyIt7 {
    width: 345px;
  }

  .EditIntrospections_textarea__D4DHM {
    width: 345px;
  }
  .EditIntrospections_wrapper__y2ebZ {
    padding: 15px;
  }
  .EditIntrospections_mainTitle__ebg5Y {
    margin-left: -15px;
  }
}

@media screen and (max-width: 400px) {
  .EditIntrospections_btnsContainer__MyIt7 {
    width: 305px;
  }

  .EditIntrospections_textarea__D4DHM {
    width: 305px;
  }
  .EditIntrospections_wrapper__y2ebZ {
    padding: 15px;
  }
  .EditIntrospections_mainTitle__ebg5Y {
    margin-left: -15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/pojediniProgrami/ProgramContainer/Components/EditIntrospections/EditIntrospections.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,qDAA6C;EAA7C,6CAA6C;EAA7C,wFAA6C;AAC/C;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,oDAAoD;EACpD,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".wrapper {\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.mainTitle {\n  font-family: Inter;\n  font-size: 30px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 35px;\n  letter-spacing: -0.016px;\n  color: #4d4d4d;\n  margin-left: -30px;\n}\n\n.backRow {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 16px;\n  transition: text-decoration 300ms ease-in-out;\n}\n.backRow:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.back {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.001em;\n  color: #5f6d7e;\n}\n\n.title {\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 25px;\n  letter-spacing: -0.016px;\n  color: #4d4d4d;\n}\n\n.introItem {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n.btnsContainer {\n  width: 600px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.textarea {\n  resize: none;\n  width: 600px;\n  min-height: 300px;\n  box-sizing: border-box;\n  padding: 15px 20px;\n  border: 1px solid #d8dbdf;\n  border-radius: 8px;\n  box-shadow: 0px 0px 30px 5px rgba(95, 109, 126, 0.1);\n  font-size: 15px;\n  font-family: \"Inter\";\n  font-weight: 400;\n  line-height: 22px;\n  color: #5f6d7e;\n}\n\n.exitButton {\n  width: 180px;\n  height: 44px;\n  border-radius: 4px;\n  gap: 8px;\n  background: #ebebeb;\n  font-family: \"Inter\";\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  border: none;\n  color: #808080;\n  cursor: pointer;\n}\n.saveButton {\n  width: 180px;\n  height: 44px;\n  border-radius: 4px;\n  gap: 8px;\n  background: #cb9c2d;\n  font-family: \"Inter\";\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  border: none;\n  color: #ffffff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.exitButton:hover {\n  background-color: #d1d0d0;\n}\n.saveButton:hover {\n  background-color: #ac8427;\n}\n\n@media screen and (max-width: 768px) {\n  .btnsContainer {\n    width: 345px;\n  }\n\n  .textarea {\n    width: 345px;\n  }\n  .wrapper {\n    padding: 15px;\n  }\n  .mainTitle {\n    margin-left: -15px;\n  }\n}\n\n@media screen and (max-width: 400px) {\n  .btnsContainer {\n    width: 305px;\n  }\n\n  .textarea {\n    width: 305px;\n  }\n  .wrapper {\n    padding: 15px;\n  }\n  .mainTitle {\n    margin-left: -15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `EditIntrospections_wrapper__y2ebZ`,
	"mainTitle": `EditIntrospections_mainTitle__ebg5Y`,
	"backRow": `EditIntrospections_backRow__jrDVe`,
	"back": `EditIntrospections_back__PSAdj`,
	"title": `EditIntrospections_title__+kjbe`,
	"introItem": `EditIntrospections_introItem__rFk1I`,
	"btnsContainer": `EditIntrospections_btnsContainer__MyIt7`,
	"textarea": `EditIntrospections_textarea__D4DHM`,
	"exitButton": `EditIntrospections_exitButton__9Np8m`,
	"saveButton": `EditIntrospections_saveButton__UvExl`
};
export default ___CSS_LOADER_EXPORT___;
